import React from 'react';

/**
 * PiExclamationMarkStroke icon from the stroke style in alerts category.
 */
interface PiExclamationMarkStrokeProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  className?: string;
  ariaLabel?: string;
}

export default function PiExclamationMarkStroke({
  size = 24,
  color,
  className,
  ariaLabel = 'exclamation-mark icon',
  ...props
}: PiExclamationMarkStrokeProps): React.JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: color || "currentColor"}}
      
      role="img"
      aria-label={ariaLabel}
      {...props}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v9m0 5v.01" fill="none"/>
    </svg>
  );
}
